
export default function Footer() {
  return (
    <footer className="bg-[#FDF8F8] border-t border-[#F0E8E8] text-[#2D2D2D] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-[#C0392B]"></i>
              </div>
              <h3 className="text-sm font-medium tracking-wider text-[#2D2D2D]">Address</h3>
            </div>
            <p className="text-sm text-[#666666] leading-relaxed">
              51 Pearn Crescent<br />
              Northcote<br />
              Auckland 0627
            </p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-time-line text-[#C0392B]"></i>
              </div>
              <h3 className="text-sm font-medium tracking-wider text-[#2D2D2D]">Business Hours</h3>
            </div>
            <p className="text-sm text-[#666666] leading-relaxed">
              SUN - THU: 11am - 9:30pm<br />
              FRI - SAT: 11am - 11pm
            </p>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-[#C0392B]"></i>
              </div>
              <h3 className="text-sm font-medium tracking-wider text-[#2D2D2D]">Contact Us</h3>
            </div>
            <p className="text-sm text-[#666666] leading-relaxed">
              <a href="mailto:yummylab@gmail.com" className="hover:text-[#C0392B] transition-colors">
                yummylab@gmail.com
              </a><br />
              021 520 768
            </p>
          </div>
        </div>

        <div className="border-t border-[#F0E8E8] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-xs text-[#AAAAAA]">
              © 2026 YUMMY LAB. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
